const queryString = require('query-string');
const { v4: uuid } = require('uuid');

const TrackingPath = {
  melidata: {
    promotions: '/promotions',
  },
};

const ALLOWED_FRAGMENT_KEYS = ['origin', 'filter_applied', 'filter_position', 'is_recommended_domain'];

const cleanObject = (obj) => {
  const result = {};

  const isEmptyObject = (elem) => {
    return typeof elem === 'object' && Object.keys(elem).length === 0;
  };
  const isEmptyArray = (elem) => {
    return Array.isArray(elem) && elem.length === 0;
  };
  Object.keys(obj).forEach((key) => {
    if (
      obj[key] !== undefined &&
      obj[key] !== null &&
      obj[key] !== '' &&
      !isEmptyObject(obj[key]) &&
      !isEmptyArray(obj[key])
    ) {
      result[key] = obj[key];
    }
  });
  return result;
};

const clearFragmentKeys = (fragmentObj = {}) => {
  const truthyValues = {};
  Object.keys(fragmentObj).forEach((key) => {
    if (ALLOWED_FRAGMENT_KEYS.includes(key)) {
      truthyValues[key] = fragmentObj[key];
    }
  });
  return truthyValues;
};

function getPersonalization(container) {
  return container ? container.split('-')[1] : 1;
}

const mapSelectors = (selectors) => {
  return selectors.map((selector, idx) => ({
    filter: selector.filter,
    position: idx + 1,
    is_recommended_domain: selector.recommended_domain || false,
  }));
};

const mapSmartGroups = (smartGroups) => {
  return smartGroups.map(({ title = '', subtitle = '', image = '', link = {} }, idx) => ({
    position: idx + 1,
    subtitle,
    title,
    image,
    link,
  }));
};

/* ****** INICIO SOLUCION TEMPORAL HASTA RE-IMPLEMENTACION DE TRACKS ****** */
const mapItems = ({ items, trackingAdditionalData = {} }) => {
  return items.map((item, index) => {
    const itemComponentsMap = {};
    item.components.forEach((cmp) => {
      itemComponentsMap[cmp.type] = cmp;
    });

    const itemId = item?.metadata?.id;
    const {
      free_shipping = false,
      promotion_type = '',
      tags = [],
      installments = {},
      price = {},
    } = trackingAdditionalData[itemId] || {};

    const installmentsValuesPrice = itemComponentsMap.price?.price?.installments?.values?.find(
      (ins) => ins.key === 'price',
    )?.price;

    return {
      title: itemComponentsMap.title?.title?.text,
      id: itemId,
      installments: {
        amount: installmentsValuesPrice?.value || 0,
        currency_id: installmentsValuesPrice?.currency || 'none',
        no_interest: !!itemComponentsMap.price?.price?.installments?.no_interest,

        price: String(installmentsValuesPrice?.value) || 'none',
        decimals: '0',
        quantity: installments?.quantity || 0, // REVISAR
      },
      pos: index,
      fulfillment: itemComponentsMap.shipping?.shipping?.icon?.key === 'vpp_full_icon',
      price: {
        currency: itemComponentsMap.price?.price?.current_price?.currency || 'none',
        decimals: '00',
        discount: itemComponentsMap.price?.price?.discount?.value || 0,
        has_loyalty_discount: price?.has_loyalty_discount || false,
        original_price: String(itemComponentsMap.price?.price?.previous_price?.value) || 'none',
        price: String(itemComponentsMap.price?.price?.current_price?.value) || 'none',
      },

      free_shipping,
      promotion_type: promotion_type || 'others',
      tags,
    };
  });
};

const mapFilterAppliedValueToOldValue = (id, value) => {
  const VALUES_MAPPED_TO_1 = ['installments', 'shipping_cost', 'sameday', 'shipping_time', 'shipping'];
  if (VALUES_MAPPED_TO_1.includes(id)) return '1';
  return value;
};

const mapFilterId = (id = '') => {
  switch (id) {
    case 'installments':
      return 'psj';
    case 'shipping_cost':
      return 'free_shipping';
    case 'category':
      return 'category_id';
    case 'shipping_time':
      return 'sameday'; // REVISAR NEXTDAY
    case 'shipping':
      return 'fulfillment';
    default:
      return id;
  }
};

const mapSelectedFilters = (filters, containerId, domainId) => {
  const result = { container_id: containerId, promotion_type: 'semfiltros' };

  if (domainId) result.domain_id = domainId;

  if (filters.length > 0) {
    filters.forEach((filter) => {
      result[mapFilterId(filter.id)] = mapFilterAppliedValueToOldValue(filter.id, filter.values[0]?.id);
    });
  }

  return result;
};

/* ****** FIN SOLUCION TEMPORAL HASTA RE-IMPLEMENTACION DE TRACKS ****** */

const mockSmartGroups = [
  {
    position: 1,
    subtitle: 'semCard',
    title: 'sem card',
    image: 'https://http2.mlstatic.com/D_Q_NP_734349-MLA79353704287_092024-C.jpg',
    link: 'naoexistecard',
  },
];

const mockFiltersApllied = 'semfiltros';

const createEventDataPromotions = ({ dealPrintId = '', data }) => {
  const {
    paging,
    items,
    selectors,
    appliedFilters,
    containerId,
    smartGroups = [],
    trackingAdditionalData,
    origin = '',
    filter_applied = '',
    filter_position = '',
    trackingAds: { tracking: padsInfo } = {},
    domain_id: domainId,
  } = data;
  const mockSelectedFilters = { container_id: containerId, promotion_type: 'none' };
  let parsedFragment = {};
  if (typeof window !== 'undefined' && window.location) {
    const fragment = (window.location.hash || '#').substring(1);
    parsedFragment = clearFragmentKeys(queryString.parse(fragment));
  }

  const result = {
    deal_print_id: dealPrintId || uuid(),
    page: {
      limit: paging.limit,
      offset: paging.offset,
      total: String(paging.total),
    },
    items: mapItems({ items, trackingAdditionalData }),
    personalization_id: parseInt(getPersonalization(containerId), 10),
    container_id_applied: containerId,
    pads_info: padsInfo,
    smartGroups: smartGroups.length > 0 ? mapSmartGroups(smartGroups) : mockSmartGroups,
    displayed_shortcuts: mapSelectors(selectors),
    selected_filters: mapSelectedFilters(appliedFilters, containerId, domainId) || mockSelectedFilters,

    ...parsedFragment,

    origin: origin || parsedFragment.origin || 'NONE',
    filter_applied: mapFilterId(filter_applied) || parsedFragment.filter_applied || mockFiltersApllied,
    filter_position: parseInt(filter_position || parsedFragment.filter_position || '0', 10),
  };

  return cleanObject(result);
};

const SendTracksPromotions = (props) => {
  if (typeof melidata === 'function') {
    melidata('send', 'view', {
      path: TrackingPath.melidata.promotions,
      event_data: createEventDataPromotions(props),
      ...(props?.data?.experiments && { experiments: props?.data?.experiments }),
    });
  }
};

module.exports = { TrackingPath, createEventDataPromotions, SendTracksPromotions };
